import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, } from '@angular/core';
import { Subscription } from 'rxjs';

import { VideogularComponent } from 'vbrick-player-src/videogular/Videogular.Component';
import { VBrickPlayerComponent } from 'vbrick-player-src/VbrickPlayer.Component';

import { AccountLicenseService } from 'rev-shared/security/AccountLicense.Service';
import { EmbedPlayerMessageBus } from 'rev-shared/embed/EmbedPlayerMessageBus.Service';
import { IVbVideoPlayerConfig } from 'rev-shared/videoPlayer/IVbVideoPlayerConfig';
import { parseUrlTimespan } from 'rev-shared/date/DateParsers.Service';
import { refreshViewerIdOverlay } from 'rev-shared/videoPlayer/VideoOverlayUtility';
import { AnalyticsViewContext } from 'rev-shared/analytics/Constant';

import { getEmbedPlayerConfig } from '../EmbedUtil';

import './embed-video.less';

@Component({
	selector: 'embed-video',
	templateUrl: './EmbedVideo.Component.html'
})
export class EmbedVideo implements OnInit, OnDestroy {
	@Input() public accountLicense: AccountLicenseService;
	@Input() public params: any;
	@Input() public embedVideoSession: any;
	@Output() public onEnded = new EventEmitter();

	@Input('video') public set videoBinding(video: any) {
		if(video !== this.video) {
			this.video = video;
			this.EmbedPlayerMessageBus.onVodLoaded(this.video);
		}
	}

	public video: any;
	public startAt: number;
	public playInLoop: boolean;
	public hideChapters: boolean;
	public playerConfig: IVbVideoPlayerConfig;
	public isVideoUnavailable: boolean;
	public vgAPI: VideogularComponent;
	public analyticsViewContext: AnalyticsViewContext = AnalyticsViewContext.Embedded;
	private subscription: Subscription;
	private prevPlayerSize: {
		width: number,
		height: number
	};

	constructor(
		private EmbedPlayerMessageBus: EmbedPlayerMessageBus
	) {}

	public ngOnInit(): void {
		this.shapeEmbedParams();
		this.isVideoUnavailable = false;
	}

	public ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}

	private shapeEmbedParams(): void {
		if (!this.params) {
			return;
		}

		this.startAt = this.params.startAt ?
			parseUrlTimespan(this.params.startAt) :
			(this.embedVideoSession?.time || 0);

		this.playInLoop = this.params.loopVideo;
		this.hideChapters = this.params.noChapters;
		this.playerConfig = getEmbedPlayerConfig(this.params);
	}

	public onPlayerReady(vgAPI: VideogularComponent, player: VBrickPlayerComponent): void {
		this.vgAPI = vgAPI;

		this.subscription = this.EmbedPlayerMessageBus.handlePlayerEvents(player, vgAPI).subscribe();
	}

	public onPlaybackEnded(): void {
		if (this.playInLoop) {
			window.setTimeout(() => this.vgAPI.play(), 500);
			return;
		}
		this.onEnded.emit();
	}

	public onPlayerSizeChanged(playerSize: { height: number, width: number}): void {
		refreshViewerIdOverlay(this.video, this.prevPlayerSize, playerSize);
		this.prevPlayerSize = playerSize;
	}

}
